/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2019, Zumper
 * @description similarListings reducers
 */

import type { Listable, NRState } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import { CLEAR_LISTABLES, ERROR_FETCHING, RECEIVE_LISTABLES } from '../constants'
import metaReducer from './metaReducer'

type Actions = ExtractActions<Values<typeof actions>>

const similarListingsReducer = combineReducers<NRState['similarListings'], Actions>({
  listables: handleActions(
    {
      [RECEIVE_LISTABLES]: (state, action) => {
        const { payload } = action
        if (payload?.listables) {
          return payload.listables
        }
        return state
      },
      [ERROR_FETCHING]: () => [],
      [CLEAR_LISTABLES]: () => [],
    },
    [] as readonly Listable[]
  ),
  meta: metaReducer,
})

export default similarListingsReducer
